var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8751 32.4141H27.2751V30.1641H29.1876C29.4981 30.1641 29.7501 29.9121 29.7501 29.6016V27.6891H32.0001V31.2891C32.0001 31.9101 31.4961 32.4141 30.8751 32.4141Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0836 32.4141H18.0715V30.1641H25.0836V32.4141ZM15.88 32.4141H11.7501C11.452 32.4141 11.1651 32.2959 10.9548 32.0844L8.91852 30.0482L10.5093 28.4574L12.0516 29.9998C12.1574 30.1056 12.3003 30.1641 12.4499 30.1641H15.8811L15.88 32.4141ZM7.3694 28.5002L5.32865 26.4594C5.11715 26.2479 4.99902 25.9622 4.99902 25.6641V21.5387H7.24902V24.9643C7.24902 25.1139 7.30865 25.2568 7.41327 25.3626L8.95902 26.9083L7.36827 28.4991L7.3694 28.5002ZM7.25015 19.3483H5.00015V12.3362H7.25015V19.3483Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25015 10.1391H5.00015V6.53906C5.00015 5.91806 5.50415 5.41406 6.12515 5.41406H9.72515V7.66406H7.81265C7.50215 7.66406 7.25015 7.91606 7.25015 8.22656V10.1391Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4076 7.66406H19.4328V5.41406H25.4076V7.66406ZM17.5664 7.66406H11.5915V5.41406H17.5664V7.66406Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 10.1391H29.7501V8.22656C29.7501 7.91606 29.4981 7.66406 29.1876 7.66406H27.2751V5.41406H30.8751C31.4961 5.41406 32.0001 5.91806 32.0001 6.53906V10.1391Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 25.8216H29.7501V19.8467H32.0001V25.8216ZM32.0001 17.9803H29.7501V12.0054H32.0001V17.9803Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8798 18.1637C19.6313 17.6293 20.2152 16.9779 20.2062 16.0071C20.2152 14.9192 19.4367 14.2194 18.4726 14.2194C17.5973 14.2194 16.748 14.8416 16.6861 16.1432H14.4755C14.5373 13.5298 16.3058 12.1978 18.4895 12.1978C20.8767 12.1978 22.5125 13.6558 22.5215 15.9677C22.5125 17.5517 21.7958 18.5811 20.6472 19.3292C19.6212 20.0188 19.1971 20.6893 19.1791 22.1473V22.3217H17.1102V22.1473C17.1282 19.6701 17.7661 18.9118 18.8798 18.1637ZM18.2082 23.4523C18.9417 23.4613 19.5695 24.0711 19.5695 24.8136C19.5695 25.5561 18.9417 26.1928 18.2082 26.1928C17.4747 26.1928 16.82 25.5741 16.829 24.8136C16.82 24.0711 17.4477 23.4602 18.2082 23.4523Z",
    fill: "#121212"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.0806fac66400d2af6e205d588989d5b8.svg";
export { ForwardRef as ReactComponent };